// #/services/workspaces/writeWorkspace.ts

import { join as pathJoin } from 'path';

import upsertJsonFile from '#/services/s3/actions/json/upsertJsonFile';
import { IWorkflow } from '#/types/workspace';
import { PATH_USERS } from '../s3/filepaths';

export async function writeWorkflow(args: {
  ownerAddress: string;
  workflowUuid: string;
  workflow: IWorkflow;
}): Promise<IWorkflow> {
  try {
    const date = new Date();
    const timestampMs = date.getTime();
    const timestampIso = date.toISOString();

    const { ownerAddress, workflowUuid, workflow } = args;

    // console.info('writeWorkflow(', JSON.stringify(args), ')');

    const userHome = pathJoin(PATH_USERS, ownerAddress);
    const userWorkflowsFolderKey = pathJoin(userHome, 'workflows/');
    const workflowKey = pathJoin(
      userWorkflowsFolderKey,
      `${workflowUuid}.json`,
    );

    const newWorkflow = {
      ...workflow,
      updatedAt: timestampIso,
    };

    // TODO: overwrite instead of merge
    await upsertJsonFile({
      s3ObjectKey: workflowKey,
      updatedJson: newWorkflow,
    });

    const userWorkflowVersionsFolderKey = pathJoin(
      userHome,
      'workflows',
      workflowUuid,
      'versions/',
    );
    const workflowVersionKey = pathJoin(
      userWorkflowVersionsFolderKey,
      `${timestampMs}.json`,
    );

    // TODO: overwrite instead of merge
    await upsertJsonFile({
      s3ObjectKey: workflowVersionKey,
      updatedJson: newWorkflow,
    });

    return newWorkflow;
  } catch (error: any) {
    console.error(error);
    throw new Error(`Error writing workflow: ${error.message}`);
  }
}
export default writeWorkflow;
